// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconTransfersPath = 'M3.042 8.992h13.917a1 1 0 0 0 .799-1.601L13.785 2.11l-1.6 1.203 2.77 3.679H5.62a2 2 0 0 0-1.551.739L3.042 8.992Zm3.175 8.883-3.974-5.281a1 1 0 0 1 .799-1.602h14l-1.026 1.262a2 2 0 0 1-1.552.738H5.046l2.769 3.68-1.598 1.203Z';
var IconTransfers = baseIcon('IconTransfers', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconTransfersPath
});
export default IconTransfers;
//# sourceMappingURL=index.js.map